"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _calendar = _interopRequireDefault(require("cccisd-icons/calendar2"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross3"));
var _circleSmall = _interopRequireDefault(require("cccisd-icons/circle-small"));
var _CalendarDialog = _interopRequireDefault(require("./CalendarDialog"));
var _style = _interopRequireDefault(require("../style.css"));
var _excluded = ["updateSessionHeldStatus", "updateSessionDate", "handleCalendarSubmit", "renderFormat"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var DatePicker = function DatePicker(_ref) {
  var updateSessionHeldStatus = _ref.updateSessionHeldStatus,
    updateSessionDate = _ref.updateSessionDate,
    handleCalendarSubmit = _ref.handleCalendarSubmit,
    _ref$renderFormat = _ref.renderFormat,
    renderFormat = _ref$renderFormat === void 0 ? 'modal' : _ref$renderFormat,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(props.wasSessionHeld),
    _useState2 = _slicedToArray(_useState, 2),
    wasSessionHeld = _useState2[0],
    setWasSessionHeld = _useState2[1];
  var _useState3 = (0, _react.useState)(props.sessionDate),
    _useState4 = _slicedToArray(_useState3, 2),
    sessionDate = _useState4[0],
    setSessionDate = _useState4[1];
  function getHeldStatus() {
    if (wasSessionHeld === undefined) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "-- / -- / --");
    }
    if (wasSessionHeld === true) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].held
      }, /*#__PURE__*/_react["default"].createElement(_circleSmall["default"], null)), "Held: ", (0, _moment["default"])(sessionDate).format('MM/DD/YYYY'));
    }
    if (wasSessionHeld === false) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].missed
      }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)), "Missed");
    }
  }
  if (renderFormat === 'page') {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        paddingTop: '2rem'
      }
    }, /*#__PURE__*/_react["default"].createElement("hgroup", {
      style: {
        display: 'flex',
        justifyContent: 'center'
      }
    }, /*#__PURE__*/_react["default"].createElement("h3", null, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_calendar["default"], {
      spaceRight: true
    })), "Please Choose Session Status and Date:")), /*#__PURE__*/_react["default"].createElement(_CalendarDialog["default"], {
      sessionHeld: wasSessionHeld,
      selectedDate: sessionDate,
      changeSessionHeld: function changeSessionHeld(e) {
        return setWasSessionHeld(e);
      },
      onDateSelect: function onDateSelect(e) {
        return setSessionDate(e.startDate);
      },
      onCalendarSubmit: function onCalendarSubmit() {
        handleCalendarSubmit({
          wasSessionHeld: wasSessionHeld,
          sessionDate: sessionDate
        });
      }
    }));
  }
  if (renderFormat === 'modal') {
    return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      title: "Please Choose Session Status and Date:",
      size: "large",
      renderTrigger: function renderTrigger(_ref2) {
        var onClick = _ref2.onClick;
        return /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-lg btn-secondary",
          onClick: wasSessionHeld !== undefined && onClick
        }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_calendar["default"], {
          spaceRight: true
        }), " ", getHeldStatus()));
      }
    }, /*#__PURE__*/_react["default"].createElement(_CalendarDialog["default"], {
      sessionHeld: wasSessionHeld,
      selectedDate: sessionDate,
      changeSessionHeld: function changeSessionHeld(e) {
        return setWasSessionHeld(e);
      },
      onDateSelect: function onDateSelect(e) {
        return setSessionDate(e.startDate);
      },
      onCalendarSubmit: function onCalendarSubmit() {
        handleCalendarSubmit({
          wasSessionHeld: wasSessionHeld,
          sessionDate: sessionDate
        });
      }
    }));
  }
};
var _default = exports["default"] = DatePicker;